/**
 * Blocks storefront render until tenant slug is resolved (subdomain or custom domain).
 */

import React, { useEffect, useState } from 'react';
import { bootstrapTenantSlug } from '../services/tenant';
import NotFound from '../pages/NotFound';

export default function TenantGate({ children }) {
  const [state, setState] = useState({ loading: true, slug: null });

  useEffect(() => {
    let cancelled = false;
    bootstrapTenantSlug().then((slug) => {
      if (!cancelled) setState({ loading: false, slug });
    });
    return () => { cancelled = true; };
  }, []);

  if (state.loading) {
    return (
      <div style={{
        position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#fdfbf7',
      }}>
        <div style={{
          width: 36, height: 36, border: '3px solid #e5e7eb',
          borderTopColor: '#2d5016', borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
      </div>
    );
  }

  if (!state.slug) {
    return <NotFound message="This site is not configured." />;
  }

  return children;
}
